import {
  GoogleMap,
  Polygon,
  Marker,
  InfoWindow,
  DrawingManager
} from '@react-google-maps/api';
import { useEffect, useState } from 'react';
import axios from 'axios';

const containerStyle = {
  width: '100%',
  height: '400px'
};

const defaultCenter = {
  lat: 34.536761,
  lng: -4.638178
};

const getColorByIndex = (index) => {
  const colors = [
    '#FF5722', '#3F51B5', '#009688', '#FFC107', '#E91E63',
    '#4CAF50', '#9C27B0', '#00BCD4', '#CDDC39', '#795548'
  ];
  return colors[index % colors.length];
};

export default function MapSelector({ position, zone, onSelect }) {
  const [drawnZone, setDrawnZone] = useState(zone || []);
  const [existingZones, setExistingZones] = useState([]);
  const [infoWindowPos, setInfoWindowPos] = useState(null);
  const [infoWindowText, setInfoWindowText] = useState('');

  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchZones = async () => {
      try {
        const res = await axios.get('http://localhost:5000/api/secteurs', {
          headers: { Authorization: `Bearer ${token}` }
        });

        const filtered = res.data
          .filter(s => s.coords && s.coords.length > 0)
          .map((s, i) => ({
            nom: s.nom,
            coords: s.coords.map(coord => ({
              lat: parseFloat(coord.lat),
              lng: parseFloat(coord.lng)
            })),
            color: getColorByIndex(i)
          }));

        setExistingZones(filtered);
      } catch (err) {
        console.error("Erreur chargement zones :", err);
      }
    };

    fetchZones();
  }, [token]);

  const handlePolygonComplete = (polygon) => {
    const path = polygon.getPath();
    const coords = [];

    for (let i = 0; i < path.getLength(); i++) {
      const point = path.getAt(i);
      coords.push({ lat: point.lat(), lng: point.lng() });
    }

    polygon.setMap(null);
    setDrawnZone(coords);

    if (position) {
      onSelect(position, coords);
    }
  };

  return (
    <div style={{ marginTop: '10px' }}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={position || defaultCenter}
        zoom={14}
        onClick={(e) => {
          const lat = e.latLng.lat();
          const lng = e.latLng.lng();
          onSelect({ lat, lng }, drawnZone);
        }}
      >
        {position && <Marker position={position} />}

        {existingZones.map((z, i) => (
          <Polygon
            key={i}
            paths={z.coords}
            options={{
              fillColor: z.color,
              fillOpacity: 0.3,
              strokeColor: z.color,
              strokeOpacity: 0.8,
              strokeWeight: 2
            }}
            onClick={(e) => {
              setInfoWindowPos(e.latLng.toJSON());
              setInfoWindowText(z.nom);
            }}
          />
        ))}

        {infoWindowPos && (
          <InfoWindow
            position={infoWindowPos}
            onCloseClick={() => setInfoWindowPos(null)}
          >
            <div><strong>{infoWindowText}</strong></div>
          </InfoWindow>
        )}

        {drawnZone.length > 2 && (
          <Polygon
            paths={drawnZone}
            options={{
              fillColor: '#4CAF50',
              fillOpacity: 0.25,
              strokeColor: '#388E3C',
              strokeWeight: 2
            }}
          />
        )}

        <DrawingManager
          onPolygonComplete={handlePolygonComplete}
          options={{
            drawingControl: true,
            drawingControlOptions: {
              position: window.google.maps.ControlPosition.TOP_CENTER,
              drawingModes: ['polygon']
            },
            polygonOptions: {
              fillColor: '#4CAF50',
              fillOpacity: 0.2,
              strokeColor: '#388E3C',
              strokeWeight: 2,
              clickable: true,
              editable: false
            }
          }}
        />
      </GoogleMap>

      <p style={{ fontSize: '0.9rem', marginTop: '10px' }}>
        {position
          ? `Position sélectionnée : ${position.lat.toFixed(6)}, ${position.lng.toFixed(6)}`
          : 'Cliquez sur la carte pour définir le centre du secteur.'}
      </p>
    </div>
  );
}
